<template>
  <div class="page">
    <div class="head-title">
      <div class="left">
        <ul class="breadcrumb">
          <li>
            <a href="#">{{ $t("salles") }}</a>
          </li>
          <li>-</li>
          <li>
            <a class="active" href="#">{{ $t("POS") }}</a>
          </li>
          <li>-</li>
          <li>
            <a class="active" href="#">{{ $t("invoices") }} {{ $t("POS") }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div class="head">
<div class="head1 mb-4">
  <h3 class="mb-3">{{ $t("invoices") }} {{ $t("POS") }}</h3>

  <div class="row g-3 align-items-center">
    <div class="col-sm-6 col-md-4 col-lg-2">
      <input type="text" class="form-control" :placeholder="$t('number')" @change="fetchData()" v-model="recid" />
    </div>

    <div class="col-sm-6 col-md-4 col-lg-2">
      <input type="date" class="form-control" :placeholder="$t('from')" @change="fetchData()" v-model="date" />
    </div>

    <div class="col-sm-6 col-md-4 col-lg-2">
      <select class="form-select" @change="fetchData()" v-model="status">
        <option value="">{{ $t("all") }}</option>
        <option value="confirmed">{{ $t("confirmed") }}</option>
        <option value="deleted">{{ $t("deleted") }}</option>
      </select>
    </div>

    <div class="col-sm-6 col-md-6 col-lg-3">
      <select class="form-select" v-model="accountpayment" @change="fetchData()">
        <option disabled value="">{{ $t("payment") }}</option>
        <option value="%">{{ $t("all") }}</option>
        <option v-for="value in accountspayment" :key="value.id || value.namear" :value="value.namear">
          {{ value.namear }}
        </option>
      </select>
    </div>

    <div class="col-sm-6 col-md-6 col-lg-2">
      <select class="form-select" v-model="accountprofite" @change="fetchData()">
        <option disabled value="">{{ $t("type") }}</option>
        <option value="%">{{ $t("all") }}</option>
        <option v-for="value in accountsprofite" :key="value.id || value.namear" :value="value.namear">
          {{ value.namear }}
        </option>
      </select>
    </div>

    <div class="col-sm-6 col-md-6 col-lg-2">
      {{ $t('shift') }}
      <input type="number" class="form-control"  v-model="shift_id" @change="fetchData()" />
    </div>

<div class="col-sm-6 col-md-6 col-lg-2">
              <button class="btn btn-primary w-100 py-2 py-md-1" @click="resetFilters()" :title="$t('reset')">
                <i class="bi bi-arrow-counterclockwise me-1"></i> {{ $t('reset') }}
              </button>
            </div>
  </div>
</div>
        <div class="head2">
          <!-- <button>
              <router-link to="/ProjectsManagement/CreateProjectsBill" class="btn-download">
                <span class="text">
                  <i class="bi bi-clipboard-plus-fill"></i>
                  {{ $t("add") }} {{ $t("invoice") }} {{ $t("purchases") }}
                </span>
              </router-link>
            </button>
            <button @click="exportToExcel()">Excel</button> -->
        </div>
      </div>
      <div class="body">
        <div class="container px-4">

          <div class="p-3 border bg-light">{{ $t("total") }} {{ $t("amount") }} : {{ totalamount }}</div>
          <div class="p-3 border bg-light">
            <ul>
              <li v-for="value in balance" :key="value">{{ value.namear }} : {{ value.balance }}</li>
            </ul>

          </div>
        </div>
<div class="table-responsive shadow-sm rounded">
          <table class="table align-middle text-nowrap mb-0">
            <thead>
              <tr>
                <th>{{ $t("code") }}</th>
                <th>{{ $t("date") }}</th>
                <th>{{ $t("time") }}</th>
                <th>{{ $t("amount") }}</th>
                <th>{{ $t("customer") }}</th>
                <th>{{ $t("mobile") }}</th>
                <th>{{ $t("details") }}</th>
                <th>{{ $t("status") }}</th>
                <th>{{ $t("payment") }}</th>
                <th>{{ $t("sales") }}</th>
                <th>{{ $t("username") }}</th>
                <th class="text-center">{{ $t("actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="val in data" :key="val.collid">
                <td>{{ val.recid }}</td>
                <td>{{ val.date }}</td>
                <td>{{ val.time }}</td>
                <td class="fw-bold">{{ val.amount }}</td>
                <td>{{ val.customer_name }}</td>
                <td>{{ val.customer_mobile }}</td>
                <td>{{ val.description }}</td>
                <td>
                  <span class="badge" :class="val.status === 'confirmed' ? 'bg-success' : 'bg-danger'">
                    {{ $t(val.status) }}
                  </span>
                </td>
                <td>{{ val.payment }}</td>
                <td>{{ val.profite }}</td>
                <td>{{ val.username }}</td>
                <td class="text-center">
                  <div class="btn-group action-buttons" role="group">
                    <button @click="view(val.recid)" class="btn btn-sm btn-outline-secondary" title="View">
                      <i class="bi bi-eye"></i>
                    </button>
                    <button @click="edit(val.recid)" class="btn btn-sm btn-outline-primary" title="Edit">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button @click="del(val.recid)" class="btn btn-sm btn-outline-danger" v-if="val.status != 'deleted'" title="Delete">
                      <i class="bi bi-trash-fill"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination">
          <div class="page-size">
            <label>{{ $t("صف كل صفحة") }}:</label>
            <select v-model="pageSize" @change="changePageSize">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <div class="page-nav">
            <button :disabled="currentPage === 1" @click="previousPage">{{ $t("previous") }}</button>
            <span v-for="page in displayedPages" :key="page">
              <button :class="{ active: currentPage === page }" @click="goToPage(page)">{{ page }}</button>
            </span>
            <button :disabled="currentPage === totalPages" @click="nextPage">{{ $t("next") }}</button>
          </div>
          <div class="page-info">
            {{ $t("page") }} {{ currentPage }} {{ $t("of") }} {{ totalPages }} ({{ $t("total") }} : {{ totalItems }})
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  name: 'POS Receipts',
  props: ["css"],

  data() {
    return {
      data: [],
      currentPage: 1,
      pageSize: 20,
      totalItems: 0,
      totalPages: 1,
      journaldate: "",
      journalid: "1",
      status: "confirmed",
      type: "",
      date: moment().format("YYYY-MM-DD"),
      recid: "",
      totalamount: 0,
      balance: [],
      accountspayment: [],
      accountsprofite: [],
      accountpayment: "",
      accountprofite: "",
      shift_id:""
    };
  },
  computed: {
    displayedPages() {
      const maxPages = 5;
      const half = Math.floor(maxPages / 2);
      let start = Math.max(1, this.currentPage - half);
      let end = Math.min(this.totalPages, start + maxPages - 1);

      if (end - start + 1 < maxPages) {
        start = Math.max(1, end - maxPages + 1);
      }

      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
  },

  async mounted() {
    this.currentPage = parseInt(this.$route.query.page, 10) || 1;
    this.pageSize = parseInt(this.$route.query.pageSize, 10) || 25;
    await this.fetchData();
    const result2 = await axios.get("/data/accountpayment");
    const result3 = await axios.get("/data/accountprofite");
    if (result2.status == 200) {
      this.accountspayment = result2.data.data;
      this.accountsprofite = result3.data.data;
    }
  },

  methods: {
view(id) {
  // Resolve the route object to get the full href/URL path
  const routeData = this.$router.resolve({ path: `/sales/salesreceiptview/${id}` });
  
  // Open the resolved URL in a new tab ('_blank')
  window.open(routeData.href, '_blank');
},
    edit(data) {
      if (data.status == 'waiting') {
        this.$root.$router.push(`/dashboard/journalentry/EditJournalEntry/${data.id}`);
      }
    },
    async del(id) {

      Swal.fire({
        title: "? هل متاكد من الحذف  ",
        text: "لن تتمكن من التراجع عن هذا! ",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const del = await axios.delete(`/pos/deleteposreceipt/${id}`);
          if (del.status == 200) {
            location.reload();
            Swal.fire("تم الحذف !", "تم حذف الفاتوره .", "success");
          }
        }
      });
    },
    async fetchData() {
      try {
        const response = await axios.get("/pos/allposreceipts", {
          params: {
            date: this.date,
            recid: this.recid,
            status: this.status,
            payment: this.accountpayment,
            profit: this.accountprofite,
            shift_id:this.shift_id,
            page: this.currentPage,
            limit: this.pageSize,
          }

        });
        const balance = await axios.get("/pos/allposbalance");
        if (response.status === 200) {
          this.data = response.data.data.data;
          this.totalItems = response.data.data.meta.total || 0;
          this.totalPages = Math.ceil(this.totalItems / this.pageSize) || 1;
          this.totalamount = response.data.data.meta.totalAmount || 0;
          this.balance = balance.data.data
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
          icon: "error",
          title: this.$t("error"),
          text: this.$t("failed_to_load_data"),
        });
      }
    },

    async search() {
      this.currentPage = 1;
      await this.updateQueryParams();
      await this.fetchData();
    },

    async updateQueryParams() {
      const query = {};
      query.page = this.currentPage;
      query.pageSize = this.pageSize;
    },

    async goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        await this.updateQueryParams();
        await this.fetchData();
      }
    },

    async previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        await this.updateQueryParams();
        await this.fetchData();
      }
    },

    async nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        await this.updateQueryParams();
        await this.fetchData();
      }
    },

    async changePageSize() {
      this.currentPage = 1;
      await this.updateQueryParams();
      await this.fetchData();
    },

    async resetFilters() {
    this.recid = "";
    this.date = moment().format("YYYY-MM-DD"); // Resets back to today's date
    this.status = "confirmed";                  // Resets to your default status
    this.accountpayment = "";
    this.accountprofite = "";
    this.currentPage = 1;                      // Go back to page 1 on filter clear
    
    // Push updates to URL if you are tracking queries, then fetch fresh data
    // await this.updateQueryParams();
    await this.fetchData();
  },

    ...mapActions(["redirectTo"]),
  },

};
</script>
<style lang="scss" scoped>
.page {
  direction: v-bind("css.EN");
  padding: 1.25rem;
  background-color: #f8f9fa;
  min-height: 100vh;
}

a {
  text-decoration: none;
}

.container-fluid {
  display: flex;
  // width: 100%;
}

.search {
  width: 80%;
  // border: #342e37 1px solid;
  box-sizing: border-box;
}

.head-option {
  direction: v-bind("css.AR");
  width: 20%;
  // border: #342e37 1px solid;
  // padding: 1%;
  text-align: v-bind("css.xdirn");
  box-sizing: border-box;
}

.head-option ul li {
  display: inline;
  // padding: 0.25%;
}

.btn-download {
  padding-right: 0.5%;
  padding-left: 0.5%;
  border-radius: 5px;
  background: v-bind("css.color");
  color: #f9f9f9;
}

.main .head {
  border-top: v-bind("css.color") 5px solid;
  background: v-bind("css.color");
  color: #f9f9f9;
  border-radius: 3px 3px 0px 0px;
  padding: 0.25%;
  text-align: v-bind("css.dirn");
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.main .body {
  background: v-bind("css.light");
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  padding: 1%;
}

button {
  margin: 1%;

}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1%;
  padding: 0.5%;
  font-size: small;
  background-color: v-bind("css.color");
  color: white;
}

.page-size {
  flex: 1;

}

.page-size select {
  margin: 1%;
  padding: 0.5%;
  border: none;
  border-radius: 5px;
  background-color: white;
}

.page-nav {
  flex: 2;
  text-align: center;

}

.page-nav button {
  margin: 0 0.25%;
  padding: 0.5% 1%;
  border: none;
  border-radius: 5px;

  background-color: white;
  color: black;
  cursor: pointer;
}

.page-nav button.active {
  background-color: v-bind("css.color");
  color: white;
  font-weight: bold;
}

.page-nav button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.page-info {
  flex: 1;
  text-align: right;

}

// Breadcrumb Elements Layout
.breadcrumb-custom {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;

  li a {
    color: #6c757d;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: v-bind("css.color");
    }

    &.active {
      color: #212529;
      font-weight: 600;
    }
  }

  .separator {
    color: #ced4da;
    user-select: none;
  }
}

// Main Card Design Layout Structure
.main-card {
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

// Top Decorative and Interactive Header Accent Bar
.card-header-accent {
  border-top: v-bind("css.color") 6px solid;
  background-color: #ffffff;
  border-bottom: 1px solid #f1f3f5;
  padding: 1.5rem;
  text-align: v-bind("css.dirn");

  .title-text {
    font-size: 1.35rem;
    font-weight: 700;
    color: #212529;
    margin: 0;
  }
}

// Body wrapper inside the container layout
.card-body-content {
  padding: 1.5rem;
  background: #ffffff;
}

// Widgets summary design system elements
.summary-widget {
  background-color: #fdfdfd;
  border-radius: 8px;
  border-color: #e9ecef !important;
}

// Responsive layout rules for standard HTML Tables
.custom-table-wrapper {
  border: 1px solid #e9ecef;

  .table {
    thead th {
      background-color: #f8f9fa;
      color: #495057;
      font-weight: 600;
      font-size: 0.85rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      padding: 1rem;
      border-bottom: 2px solid #e9ecef;
    }

    tbody td {
      padding: 1rem;
      font-size: 0.9rem;
      border-bottom: 1px solid #f1f3f5;
    }
  }
}

// Styled Footer Alignment Layout Control
.pagination-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  padding: 1rem;
  border-radius: 8px;
  gap: 1rem;

  .footer-segment {
    width: 100%;
  }
}

@media (min-width: 768px) {
  .page-size { justify-content: flex-start; width: auto; }
  .page-nav { justify-content: center; width: auto; }
  .page-info { justify-content: flex-end; width: auto; }
  .page { padding: 1.5rem; }
}

.page-nav button {
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &.active {
    background-color: rgba(0,0,0,0.2) !important;
    color: white !important;
    border: 1px solid rgba(255,255,255,0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

// Media Query override modifiers targeting form field sizes on mobile screens
@media (max-width: 576px) {
  .form-control-lg-custom {
    padding: 0.75rem 1rem;
    font-size: 1rem;
  }
  
  .head1 h3 {
    font-size: 1.25rem !important;
  }
}
</style>
